import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../features/auth/AuthContext'
import type { AppRole } from '../features/auth/auth.types'

export default function RoleRoute({ allowedRoles }: { allowedRoles: readonly AppRole[] }) {
  const { user } = useAuth()

  if (!user || !allowedRoles.some((role) => user.roles.includes(role))) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
